import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
  deleteOrganizationLogo,
  uploadOrganizationLogo,
} from '@/api/services/organization.service'
import { getErrorMessage } from '@/lib/getErrorMessage'
import { organizationQueryKeys } from './useCurrentOrganization'

export function useUploadOrganizationLogo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (file: File) => uploadOrganizationLogo(file),
    onSuccess: (organization) => {
      queryClient.setQueryData(organizationQueryKeys.current, organization)
      toast.success('Logo updated')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}

export function useDeleteOrganizationLogo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => deleteOrganizationLogo(),
    onSuccess: (organization) => {
      queryClient.setQueryData(organizationQueryKeys.current, organization)
      toast.success('Logo removed')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}
